import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useParallelPersona } from "../../context/ParallelPersonaContext";

const ParallelLoadingPage = () => {
  const { setPersonas, setPersonaData } = useParallelPersona();
  const navigate = useNavigate();
  const { state: requestBody } = useLocation();

  useEffect(() => {
    const fetchPersonas = async () => {
      try {
        const response = await fetch(
          "https://docker-compose-dev-primepersonacreator-83cd036b.koyeb.app/persona",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(requestBody),
          }
        );
        const data = await response.json();
        setPersonas(data.personas);
        setPersonaData(data);
        navigate("/parallel/personas");
      } catch (error) {
        navigate("/error");
        console.error("Failed to fetch personas", error);
      }
    };

    fetchPersonas();
  }, [navigate, setPersonas, requestBody]);

  return (
    <div className="loading-page">
      <h2>Generating Personas...</h2>
      <p>Please wait while we fetch the results.</p>
    </div>
  );
};

export default ParallelLoadingPage;
